interface TCSCallback {
  success(): void
  termination(): void
  close(): void
  error(): void
}

export const useCallbacksTCS = () => {
  const windowAny = window as any

  const iOSCallbacks: TCSCallback = {
    success() {
      windowAny.webkit.messageHandlers.parkingpayTransactionSuccess.postMessage(
        null,
      )
    },

    termination() {
      windowAny.webkit.messageHandlers.parkingpayTransactionTermination.postMessage(
        null,
      )
    },

    close() {
      windowAny.webkit.messageHandlers.parkingpayTransactionClose.postMessage(
        null,
      )
    },

    error() {
      // window.alert("Error callback iOS called")
      windowAny.webkit.messageHandlers.parkingpayTransactionError.postMessage(
        null,
      )
    },
  }

  const androidCallbacks: TCSCallback = {
    success() {
      windowAny.android.parkingpayTransactionSuccess()
    },

    termination() {
      windowAny.android.parkingpayTransactionTermination()
    },

    close() {
      windowAny.android.parkingpayTransactionClose()
    },

    error() {
      windowAny.android.parkingpayTransactionError()
    },
  }

  const unknownCallbacks: TCSCallback = {
    success() {
      // window.alert("Success called - OS Type unknown")
    },

    termination() {
      // window.alert("Termination called - OS Type unknown")
    },

    close() {
      // window.alert("Close called - OS Type unknown")
    },

    error() {
      // window.alert("Erorr called - Type unknown")
    },
  }

  const callbacks: TCSCallback = windowAny.android
    ? androidCallbacks
    : windowAny.webkit && windowAny.webkit.messageHandlers
    ? iOSCallbacks
    : unknownCallbacks

  return {
    callbacks,
  }
}

/*
// Code from Christian Gauch iAgentur
var r, o, a = function() {
  var e = (window as any);
  return e.android ? e.android : e.webkit && e.webkit.messageHandlers ? {
      parkingpayTransactionSuccess: i(),
      parkingpayTransactionError: s(),
      parkingpayTransactionTermination: l()
  } : null
};


function i() {
  var e = (window as any);
  return e.webkit && e.webkit.messageHandlers && e.webkit.messageHandlers.parkingpayTransactionSuccess ? function() {
      return e.webkit.messageHandlers.parkingpayTransactionSuccess.postMessage(null)
  }
  : function() {
      return null
  }
}
function s() {
  var e = (window as any);
  return e.webkit && e.webkit.messageHandlers && e.webkit.messageHandlers.parkingpayTransactionError ? function() {
      return e.webkit.messageHandlers.parkingpayTransactionError.postMessage(null)
  }
  : function() {
      return null
  }
}
function l() {
  var e = (window as any);
  return e.webkit && e.webkit.messageHandlers && e.webkit.messageHandlers.parkingpayTransactionTermination ? function() {
      return e.webkit.messageHandlers.parkingpayTransactionTermination.postMessage(null)
  }
  : function() {
      return null
  }
}
*/
